module.exports = __webpack_public_path__ + "static/media/Banner_lp.14492cee.png";